import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';

import { ExtendedRouteProps } from 'app/lib/routing/types';
import { ReduxState } from 'app/redux/types';

import { AUTH_QUERY_KEY, AuthModalQuery } from 'app/modules/Signing/utils/auth-modals-query';
import { getIsLogoutSuccess } from 'app/redux/selectors/auth';

import { clientId, selectClientInfoLoading } from '../../account/selectors';

type PrivateRouteProps = {
  isLoggedIn: boolean;
  clientInfoLoading: boolean;
  isLogoutSuccess: boolean;
};

const PrivateRouteWithoutHOC: FC<PrivateRouteProps & ExtendedRouteProps> = ({
  isLoggedIn,
  clientInfoLoading,
  isLogoutSuccess,
  exact,
  path,
  component: Component,
  routes,
}) => {
  const { pathname } = useLocation();
  if (!isLoggedIn && !clientInfoLoading) {
    return (
      <Redirect to={{
        pathname: '/',
        search: createSearchParams(isLogoutSuccess, pathname),
      }} />
    );
  }

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <Component
          {...props}
          routes={routes} />
      )} />
  );
};

function createSearchParams(isLogoutSuccess: boolean, path?: string | string[]) {
  const searchParams = new URLSearchParams();

  if (!isLogoutSuccess) {
    searchParams.set(AUTH_QUERY_KEY, AuthModalQuery.LOGIN);
  }

  if (typeof path === 'string') {
    searchParams.set('from', path);
  }

  return `?${searchParams.toString()}`;
}

const mapStateToProps = (state: ReduxState): PrivateRouteProps => ({
  isLoggedIn: !!clientId(state),
  clientInfoLoading: selectClientInfoLoading(state),
  isLogoutSuccess: getIsLogoutSuccess(state),
});

export const PrivateRoute = connect(mapStateToProps)(PrivateRouteWithoutHOC);
